


















































import Vue from 'vue';
import { FormFieldValidation, RouteHelpers, ObjectHelper } from '@/mixins';
import {
  DocuSignTemplateSignHereModel,
  DocuSignTemplateSignHereConfigurationModel,
  DocuSignTemplateSignHereCreateUpdateModel,
  DocuSignTemplateSignHereSearchModel,
  Dictionary,
  Configuration
} from '@/types';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import DocuSignUpdateTemplateSignHere from '@/components/configuration/docuSign/DocuSignUpdateTemplateSignHere.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
export default Vue.extend({
  name: 'DocuSignTemplateSignHere',
  mixins: [FormFieldValidation, RouteHelpers, ObjectHelper],
  data() {
    return {
      isLoading: false,
      hasError: false,
      errorMessage: '',
      submitIsLoading: false,
      serverValidationMessage: '',
      docuSignTemplateSignHereModel: {} as DocuSignTemplateSignHereModel,
      docuSignTemplateSignHereConfigurationModel: {} as DocuSignTemplateSignHereConfigurationModel
    };
  },
  methods: {
    async getData(this: any, id: number) {
      this.isLoading = true;
      try {
        // tslint:disable-next-line:max-line-length
        this.docuSignTemplateSignHereConfigurationModel = await DocuSignConfigurationService.getTemplateSignHereConfiguration(
          {
            documentTypeId: this.documentTypeId,
            templateSignHereId: this.templateSignHereId
          } as DocuSignTemplateSignHereSearchModel
        );
        this.docuSignTemplateSignHereModel = this.docuSignTemplateSignHereConfigurationModel.templateSignHere;
      } catch (error) {
        this.$log('Error getting additional document sign tab');
      } finally {
        this.isLoading = false;
      }
    },
    async onSubmit(this: any, docuSignTemplateSignHereUpdateModel: DocuSignTemplateSignHereCreateUpdateModel) {
      this.resetFormValidation();
      try {
        this.submitIsLoading = true;
        const result = await DocuSignConfigurationService.updateTemplateSignHereAsync(
          this.templateSignHereId,
          docuSignTemplateSignHereUpdateModel
        );

        if (result.hasNotification && !result.showToast) {
          this.serverValidationMessage = result.notification;
          this.submitIsLoading = false;
          return;
        }

        SnotifyConfiguration.showSuccess('Signer Location updated successfully.');
        this.setApplicationDirty(false);
        this.navigateToTemplateSignHereManagement();
      } catch (error) {
        this.serverValidationMessage = 'Error updating Signer Location';
      } finally {
        this.submitIsLoading = false;
      }
    },
    navigateToTemplateSignHereManagement(this: any) {
      const param = {} as Dictionary<any>;
      param.documentTypeId = this.documentTypeId;
      param.templateId = this.templateId;
      this.$router.push({
        name: Configuration.DocuSign.TemplateSignHere.Management.name,
        params: param
      });
    }
  },
  computed: {
    documentTypeId(): number {
      return Number(this.$route.params.documentTypeId);
    },
    templateId(): number {
      return Number(this.$route.params.templateId);
    },
    templateSignHereId(): number {
      return Number(this.$route.params.id);
    },
    headerText(this: any) {
      return this.tabName ? `Edit Sign Location (${this.tabName})` : 'Edit Sign Location';
    }
  },
  mounted(this: any) {
    this.getData();
  },
  components: {
    LoadingSpinner,
    DocuSignUpdateTemplateSignHere
  }
});
